import genReducer from "../core/reducer";
import types from "./types";
import initialState from "./initialState";

export const POST_VIEWS_MODEL = "postViews";

export default genReducer(types, initialState);
